import { Controller } from "@hotwired/stimulus"

// One Zalora picture in all its versions: the option as first delivered and
// every revision the studio sent after a note. A tab per version swaps the
// pane, and a revision can be laid over the original with the before/after
// slider so the client sees exactly what changed.
//
//   <article data-controller="zalora-versions">
//     <button data-zalora-versions-target="tab" data-action="zalora-versions#show"
//             data-zalora-versions-index-param="0">
//     <div data-zalora-versions-target="pane">
//       <button data-action="zalora-versions#compare">
export default class extends Controller {
  static targets = ["tab", "pane"]

  show({ params: { index } }) {
    this.paneTargets.forEach((pane, i) => { pane.hidden = i !== index })
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle("is-active", i === index)
      tab.setAttribute("aria-selected", i === index)
    })
  }

  // Toggles the pane between the version alone and the version over the original.
  compare(event) {
    const pane = event.currentTarget.closest("[data-zalora-versions-target='pane']")
    const on = pane.classList.toggle("is-comparing")
    event.currentTarget.setAttribute("aria-pressed", on)
  }
}
